import { Country } from 'country-state-city';
import { COUNTRY_TRANSLATIONS } from './country-translations.constants';

export function normalizeString(str: string | undefined | null): string {
  if (!str) return '';
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}

export function translateCountryName(country: string | undefined | null): string {
  if (!country) return '';
  const normalized = normalizeString(country);
  const translated = COUNTRY_TRANSLATIONS[normalized];
  return translated || country;
}

export function getCountryIsoCode(countryNameOrCode: string | undefined | null): string {
  if (!countryNameOrCode) return '';
  const normalizedInput = normalizeString(translateCountryName(countryNameOrCode));
  const countryObj = Country.getAllCountries().find(c => 
    normalizeString(c.name) === normalizedInput || normalizeString(c.isoCode) === normalizedInput
  );
  return countryObj ? countryObj.isoCode : countryNameOrCode;
}

export function getCountryName(countryNameOrCode: string | undefined | null): string {
  if (!countryNameOrCode) return '';
  const normalizedInput = normalizeString(translateCountryName(countryNameOrCode));
  const countryObj = Country.getAllCountries().find(c => 
    normalizeString(c.name) === normalizedInput || normalizeString(c.isoCode) === normalizedInput
  );
  return countryObj ? countryObj.name : countryNameOrCode;
}
